const apiUrl = import.meta.env.VITE_API_URL

if (import.meta.env.PROD && !apiUrl) {
	console.error('[Config] VITE_API_URL is not set. API requests will fail.')
}

export const API_URL = apiUrl ?? ''
